import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

export interface OrderControlsProps {
  orderNum: number;
  canMoveUp: boolean;
  canMoveDown: boolean;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
}

export const OrderControls: React.FC<OrderControlsProps> = ({
  orderNum,
  canMoveUp,
  canMoveDown,
  onMoveUp,
  onMoveDown
}) => {
  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm font-medium text-text-primary">
        {orderNum}
      </span>
      <div className="flex flex-col space-y-1">
        {canMoveUp && onMoveUp && (
          <button
            onClick={onMoveUp}
            className="text-text-secondary hover:text-primary-600 transition-colors"
            title="Move Up"
          >
            <ArrowUp className="w-3 h-3" />
          </button>
        )}
        {canMoveDown && onMoveDown && (
          <button
            onClick={onMoveDown}
            className="text-text-secondary hover:text-primary-600 transition-colors"
            title="Move Down"
          >
            <ArrowDown className="w-3 h-3" />
          </button>
        )}
      </div>
    </div>
  );
};
